module.exports = "/_next/static/images/OgProductCcpa-ee09ffd4851a366bc8d0c62702f8a892.png";